import { ENVIO_ENDPOINT, ENVIO_WS_ENDPOINT } from '$lib/constants/envioEndpoint';
import { SharedState } from '$utils/sharedState.svelte';

class StateEnvioEndpoint extends SharedState<{ wss: string; https: string }> {
  public change(endpoint: string) {
    const baseUrl = `//indexer.dev.hyperindex.xyz/${endpoint}/v1/graphql`;
    this.set({ https: `https:${baseUrl}`, wss: `wss:${baseUrl}` });
  }

  get current() {
    return (
      super.current ?? {
        https: ENVIO_ENDPOINT!,
        wss: ENVIO_WS_ENDPOINT!,
      }
    );
  }
}

export const stateEnvioEndpoint = new StateEnvioEndpoint(null);
